import React, { Component } from "react";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";

class DataKonsumenInputs extends Component {
  constructor(props) {
    super(props);
    this.viewOnly = props.activity === "VIEW";
  }

  render() {
    return (
      <>
        <h4>Data Konsumen</h4>
        <div style={{ display: "flex", alignItems: "end", gap: "7px" }}>
          <SimpleInput
            id="input_text_nama_konsumen"
            name="customerName"
            label="Nama Pembeli"
            containerclassname="flex-1 margin-bottom-none"
            mandatory={!this.viewOnly}
            readOnly={this.viewOnly}
            errorMessage={this.props.errors?.customerName}
            value={this.props.data?.customerName}
            onChange={({ target }) => this.props.onChangeInput(target.name, target.value)}
          />
          {!this.viewOnly && (
            <SimpleButton
              type="button"
              category="action_button"
              className="btn"
              styles={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
              icon={<i className="fa fa-search"></i>}
              onClick={this.props.onClickDataCustomer}
            />
          )}
        </div>
        <SimpleInput
          id="input_text_member_id"
          name="memberID"
          label="Member ID"
          readOnly
          value={this.props.data?.memberID}
          // onChange={({ target }) => this.props.onChangeInput(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_nik"
          name="customerKTPNumber"
          label="NIK"
          box="onlyNumber"
          maxLength={16}
          readOnly={this.viewOnly}
          mandatory={!this.viewOnly}
          errorMessage={this.props.errors?.customerKTPNumber}
          value={this.props.data?.customerKTPNumber}
          onChange={({ target }) => this.props.onChangeInput(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_no_hp"
          name="customerHpNumber"
          label="No. HP"
          box="onlyNumber"
          maxLength={12}
          readOnly={this.viewOnly}
          mandatory={!this.viewOnly}
          errorMessage={this.props.errors?.customerHpNumber}
          value={this.props.data?.customerHpNumber}
          onChange={({ target }) => this.props.onChangeInput(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_no_wa"
          name="customerWaNumber"
          label="No. WA"
          box="onlyNumber"
          maxLength={12}
          mandatory
          readOnly={this.viewOnly}
          errorMessage={this.props.errors?.customerWaNumber}
          value={this.props.data?.customerWaNumber}
          onChange={({ target }) => this.props.onChangeInput(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_email"
          name="email"
          label="Email"
          readOnly={this.viewOnly}
          value={this.props.data?.email}
          onChange={({ target }) => this.props.onChangeInput(target.name, target.value)}
        />
        <SimpleTextArea
          id="input_text_alamat"
          name="customerAddress"
          label="Alamat"
          typeInputCase="normal"
          mandatory={!this.viewOnly}
          readOnly={this.viewOnly}
          errorMessage={this.props.errors?.customerAddress}
          value={this.props.data?.customerAddress}
          onChange={({ target }) => this.props.onChangeInput(target.name, target.value)}
        />
        <SimpleDDL
          id="select_options_provinsi"
          name="customerProvinceId"
          label="Provinsi"
          box="search"
          readOnly={this.viewOnly}
          isClearable
          mandatory
          errorMessage={this.props.errors?.customerProvinceId}
          options={this.props.state?.provinceOptions}
          value={this.props.data?.customerProvinceId}
          onChange={(value, { name }) => this.props.onChangeProvince(name, value)}
        />
        <SimpleDDL
          id="select_options_kota"
          name="customerKabKotId"
          label="Kota"
          box="search"
          isClearable
          mandatory
          errorMessage={this.props.errors?.customerKabKotId}
          readOnly={!this.props.data?.customerProvinceId || this.viewOnly}
          options={this.props.state?.kotaOptions}
          value={this.props.data?.customerKabKotId}
          onChange={(value, { name }) => this.props.onChangeKota(name, value)}
        />
        <SimpleDDL
          id="select_options_kecamatan"
          name="customerKecamatanId"
          label="Kecamatan"
          box="search"
          isClearable
          mandatory
          errorMessage={this.props.errors?.customerKecamatanId}
          readOnly={!this.props.data?.customerKabKotId || this.viewOnly}
          options={this.props.state?.kecamatanOptions}
          value={this.props.data?.customerKecamatanId}
          onChange={(value, { name }) => this.props.onChangeKecamatan(name, value)}
        />
          <SimpleDDL
              id="select_options_kelurahan"
              name="customerKelurahanId"
              label="Kelurahan"
              box="search"
              isClearable
              mandatory
              errorMessage={this.props.errors?.customerKelurahanId}
              readOnly={!this.props.data?.customerKecamatanId || this.viewOnly}
              options={this.props.state?.kelurahanOptions}
              value={this.props.data?.customerKelurahanId}
              onChange={(value, { name }) => this.props.onChangeKelurahan(name, value)}
          />
        <SimpleDDL
          id="select_options_kode_pos"
          name="customerZipCode"
          label="Kode Pos"
          box="search"
          isClearable
          mandatory
          errorMessage={this.props.errors?.customerZipCode}
          readOnly={!this.props.data?.customerKelurahanId || this.viewOnly}
          options={this.props.state?.zipCodeOptions}
          value={this.props.data?.customerZipCode}
          onChange={(value, { name }) => this.props.onChangeInput(name, value)}
        />
      </>
    );
  }
}

export default DataKonsumenInputs;
